import { request } from './api';
import * as Alert from './alert';

/**
 * Action constants
 */
export const EFFICIENTFRONTIER_REQUEST = 'EFFICIENTFRONTIER_REQUEST';
export const EFFICIENTFRONTIER_FETCH_SUCCESS =
  'EFFICIENTFRONTIER_FETCH_SUCCESS';
export const EFFICIENTFRONTIER_UPDATE = 'EFFICIENFRONTIER_UPDATE';
export const EFFICIENTFRONTIER_FAIL = 'EFFICIENTEFFICIENTFRONTIER_FAIL';
export const EFFICIENTFRONTIER_CLEAR = 'EFFICIENTEFFICIENTFRONTIER_CLEAR';
export const EFFICIENTFRONTIER_ABORT = 'EFFICIENTFRONTIER_ABORT';

/**
 * Action creators
 */
let controller = new AbortController();

export function fetchParams(params) {
  return (dispatch) => {
    controller = new AbortController();
    dispatch({ type: EFFICIENTFRONTIER_REQUEST, abortController: controller });

    return dispatch(
      request('post', `/portfolio/efficient-frontier/`, {
        body: params,
        signal: controller.signal,
      })
    ).then(
      (data) => {
        return dispatch({
          type: EFFICIENTFRONTIER_FETCH_SUCCESS,
          data,
        });
      },
      (error) => {
        if (controller.signal.aborted) {
          return;
        }
        const parsedError = parseErr(error);
        dispatch({ type: EFFICIENTFRONTIER_FAIL });
        dispatch(Alert.show({ type: 'error', msg: parsedError }));
      }
    );
  };
}

export function update(field, value) {
  return {
    type: EFFICIENTFRONTIER_UPDATE,
    field,
    value,
  };
}

export function abortFetching() {
  return (dispatch) => {
    // Abort.
    controller.abort();
    dispatch({ type: EFFICIENTFRONTIER_ABORT });
  };
}

/**
 * Helper Functions
 */
function parseErr(error) {
  let parsedError =
    error.msg ||
    error.detail ||
    error.error ||
    'Something went wrong. Please modify your holdings and try again.';
  if (parsedError === 'Connection Timeout') {
    parsedError =
      'Sorry, the Optimizer has timed out. Please revisit your holdings and/or average return assumptions.';
  }
  return parsedError;
}
